import { BaseClient } from './BaseClient'

export class PartnersApi extends BaseClient {
  categories = {
    get: this.createRequest({
      url: `/api/public/affiliate/categories`,
      method: 'get',
    }),
  }

  list = {
    get: this.createRequest({
      url: '/api/public/affiliate/partners',
      method: 'get',
    }),
  }

  item = {
    get: (slug, locale) =>
        this.createRequest({
          url: `/api/public/affiliate/partners/${slug}?locale=${locale}`,
          method: 'get',
        }),
  }
}
